import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    De magische kracht van muziek tijdens je krachttraining
                </title>
                <link rel="canonical" href={route("blogs.fifty-six")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hey daar, ijzerpompende fitnessfanaat! Heb je je ooit afgevraagd waarom je favoriete nummers je kunnen helpen om net die extra herhaling eruit te persen? Nou, dat is geen toeval. Het is wetenschap, baby! Muziek kan je krachttraining daadwerkelijk naar een hoger niveau tillen. En nee, we hebben het niet over de 'Ik heb een potje met vet' sing-a-long tijdens je squats. Laten we eens kijken waarom muziek je helpt bij krachttraining en welke beats per minuut (BPM) het meest geschikt zijn voor betere prestaties."
                />
                <meta
                    property="og:description"
                    content="Hey daar, ijzerpompende fitnessfanaat! Heb je je ooit afgevraagd waarom je favoriete nummers je kunnen helpen om net die extra herhaling eruit te persen? Nou, dat is geen toeval. Het is wetenschap, baby! Muziek kan je krachttraining daadwerkelijk naar een hoger niveau tillen. En nee, we hebben het niet over de 'Ik heb een potje met vet' sing-a-long tijdens je squats. Laten we eens kijken waarom muziek je helpt bij krachttraining en welke beats per minuut (BPM) het meest geschikt zijn voor betere prestaties."
                />
                <meta property="og:url" content={route("blogs.fifty-six")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De magische kracht van muziek tijdens je krachttraining - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/muziek.png" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/muziek.webp"
                                    type="image/webp"
                                    alt="Muziek"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/muziek.png"
                                    type="image/jpeg"
                                    alt="Muziek"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/muziek.png"
                                    alt="Muziek"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De magische kracht van muziek tijdens je krachttraining
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Hey daar, ijzerpompende fitnessfanaat! Heb je je ooit
                        afgevraagd waarom je favoriete nummers je kunnen helpen
                        om net die extra herhaling eruit te persen? Nou, dat is
                        geen toeval. Het is wetenschap, baby! Muziek kan je
                        krachttraining daadwerkelijk naar een hoger niveau
                        tillen. En nee, we hebben het niet over de 'Ik heb een
                        potje met vet' sing-a-long tijdens je squats. Laten we
                        eens kijken waarom muziek je helpt bij krachttraining en
                        welke beats per minuut (BPM) het meest geschikt zijn
                        voor betere prestaties.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom muziek je helpt bij krachttraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Volgens een studie van Karageorghis en Priest (2012) kan
                        muziek je helpen om je aandacht af te leiden van de pijn
                        en vermoeidheid tijdens je training. Dus, terwijl je
                        spieren schreeuwen "stop, we kunnen niet meer!", zegt je
                        brein "Hé, dit is mijn jam! Nog één set!".
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De magie van BPM
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Maar niet alle muziek is gelijk geschapen als het gaat
                        om krachttraining. Het is allemaal een kwestie van BPM.
                        Een studie van Simpson en Karageorghis (2006) toonde aan
                        dat muziek met een hoger tempo (125-140 BPM) de beste
                        resultaten opleverde voor krachttraining. Dus, sorry
                        voor de fans van ballades, maar 'My Heart Will Go On' is
                        misschien niet de beste keuze voor je deadlifts.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe je muziek het beste kunt toepassen tijdens je
                        krachttraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Oké, dus hoe pas je deze kennis toe in de praktijk?
                        Simpel. Maak een afspeellijst met nummers die binnen het
                        ideale BPM-bereik vallen. Zorg ervoor dat de nummers die
                        je kiest je motiveren en je in de stemming brengen om te
                        zweten. Je kunt ook gebruik maken van
                        muziekstreamingdiensten die al afspeellijsten hebben
                        gemaakt op basis van BPM. Zo hoef je niet zelf elk
                        nummer te analyseren, tenzij je dat leuk vindt
                        natuurlijk.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Voorbeeldnummers met de ideale BPM
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Om je op weg te helpen, hier zijn een paar
                        voorbeeldnummers die binnen het ideale BPM-bereik vallen
                        voor krachttraining:
                    </p>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>'Till I Collapse' van Eminem (171 BPM)</li>
                        <li>
                            'Can't Hold Us' van Macklemore & Ryan Lewis (146
                            BPM)
                        </li>
                        <li>'Eye of the Tiger' van Survivor (109 BPM)</li>
                        <li>
                            'Turn Down for What' van DJ Snake & Lil Jon (100
                            BPM)
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        En ja, we weten dat 'Eye of the Tiger' en 'Turn Down for
                        What' technisch gezien onder het ideale BPM-bereik
                        vallen, maar kom op, wie kan er nou niet pompen op die
                        nummers?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Dus daar heb je het. Muziek kan je krachttraining
                        daadwerkelijk verbeteren, en het is allemaal te danken
                        aan de wetenschap. Dus de volgende keer dat je in de
                        sportschool bent, vergeet dan niet je koptelefoon en je
                        killer afspeellijst. En vergeet niet, het gaat niet
                        alleen om het hebben van de juiste muziek, maar ook om
                        het hebben van de juiste houding. Dus ga erheen, pomp
                        wat ijzer, en onthoud: je bent een beest!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Karageorghis, C. I., & Priest, D. L. (2012). Music in
                        the exercise domain: a review and synthesis (Part II).
                        International Review of Sport and Exercise Psychology,
                        5(1), 67-84.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Simpson, S. D., & Karageorghis, C. I. (2006). The
                        effects of synchronous music on 400-m sprint
                        performance. Journal of sports sciences, 24(10),
                        1095-1102.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
